import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/ProjectsAndVessels/Ship/add'
import constant from '../../../constant'
import { toast } from 'react-toastify'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { v3_edit_ship } from '../../../actions/v3/projectAndVessel'
const Add = (props) => {

    const location = useLocation();
    const { data, page } = location.state || {};
    const onSubmit = (model) => {
        model.previousName = JSON.parse(atob(data))['NAME']
        model.shipId = JSON.parse(atob(data))['ID']

        v3_edit_ship(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.listShipMasterData.url, {
                    page: page // Replace 'yourData' with the data you want to pass
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }
    return (
        <React.Fragment>
            <Layout
                title={'Vessels'}>
                <Form
                    title={'Edit Vessel'}
                    onSubmit={onSubmit}
                    data={JSON.parse(atob(data))}
                    buttonName={'Save Vessel'}

                />
            </Layout>

        </React.Fragment>
    )
}

export default Add